/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actions
import {reorderContents, selectContent, invalidateSelectedContent, updateNoLiveContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { sendMessage } from 'utils/messages';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import ContentSelector from 'pages/dashboard/embeds/management/customize/contentselector/contentselector';



/* ========== ~~~~~~~~~~ CONTENT SELECTOR : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    return {
        location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
        contents: embedsState.embedManagementState.contentStatus.contents,
        selectedContent: !!contentStatus.contents ? contentStatus.contents[contentStatus.selectedContent] : null,
        noLiveContents: contentStatus.noLiveContents
    }
};

const mapDispatchToProps = dispatch => ({
    selectContent: contentId => dispatch(selectContent(contentId)),
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
    sendMessage: message => dispatch(sendMessage(message)),
    reorderContents: (liveContents, inactiveContents) => dispatch(reorderContents(liveContents, inactiveContents)),
    updateNoLiveContent: bool => dispatch(updateNoLiveContent(bool))
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContentSelector);